import DKMap from "../maps/DKMap";

function MainPage() {
  return (
    <div className='w-full h-screen'>
        <div className='bg-black h-[60px] flex justify-between items-center p-[10px]'>
            <select id="countries" className="w-[200px] bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                <option value="world">Select the country</option>
                <option value="DK">Denmark</option>
                <option value="FR">France</option>
                <option value="DE">Germany</option>
                <option value="SE">Sweden</option>
                <option value="GB">UK</option>
                <option value="US">USA</option>
            </select>
        </div>
        <div className='w-full h-[calc(100vh-60px)]'>
            <DKMap />
        </div>
    </div>
  );
}

export default MainPage;